export default __webpack_public_path__ + "static/media/instant-rebate-ico-active.1e3444c1.svg";